module.exports = __webpack_public_path__ + "media/grupo-rv.f109db73.png";